import React from 'react';
import { Box, Grid, Typography, List, ListItem, Divider } from '../../../../imports/muiImport';
import { useSelector } from '../../../../imports/generalImport';

export default function UserDetailPayment() {
  const userProfile = useSelector((state) => state.UserProfile.allData?.data);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          sx={{
            background: 'linear-gradient(180deg, #0B4AA2 0%, #0A3C84 100%)',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            px: 2,
            py: 1.25,
            mt: 2,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'white.main',
              fontWeight: 500,
              fontSize: '1.1rem',
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            Receiver Details
          </Typography>
        </Box>

        {/* Content box */}
        <Box
          sx={{
            border: '1.5px solid',
            borderColor: 'divider',
            borderTop: 'none', // To connect with header
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            backgroundColor: 'white.main',
            px: 2,
            py: 2,
            minHeight: { xs: 120, lg: 160 },
          }}
        >
          <List disablePadding>
            {[
              { label: 'Name', value: userProfile?.name || '-' },
              { label: 'Phone', value: userProfile?.mobile || '-' },
              { label: 'Email', value: userProfile?.email?.toLowerCase() || '-' },
            ].map(({ label, value }, i) => (
              <React.Fragment key={label}>
                <ListItem sx={{ px: 0, py: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      flex: 1,
                      fontSize: { xs: '1rem', md: '1.1rem' },
                      textAlign: 'left',
                      wordBreak: 'break-word',
                      fontWeight: 400,
                      color: 'textPrimary.main',
                    }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      flexGrow: 1,
                      fontSize: { xs: '1rem', md: '1.1rem' },
                      textAlign: 'right',
                      wordBreak: 'break-word',
                      fontWeight: 400,
                      color: 'textPrimary.main',
                    }}
                  >
                    {value}
                  </Typography>
                </ListItem>
                {i < 2 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Grid>
    </Grid>
  );
}
